import mime from 'mime-types'

export function getFileExtension(mimeType?: File['type']) {
  return mime.extension(mimeType ?? '').toString()
}
